module.exports = __webpack_public_path__ + "img/ot-joe-pa.3bf0c27e.png";